import React from 'react';

export const FullScreen = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">
    <path
      fill="#fff"
      d="M21 8.5c-.6 0-1-.4-1-1V4h-3.5c-.6 0-1-.4-1-1s.4-1 1-1H21c.6 0 1 .4 1 1v4.5c0 .6-.4 1-1 1zM21 22h-4.5c-.6 0-1-.4-1-1s.4-1 1-1H20v-3.5c0-.6.4-1 1-1s1 .4 1 1V21c0 .6-.4 1-1 1zM7.5 22H3c-.6 0-1-.4-1-1v-4.5c0-.6.4-1 1-1s1 .4 1 1V20h3.5c.6 0 1 .4 1 1s-.4 1-1 1zM3 8.5c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h4.5c.6 0 1 .4 1 1s-.4 1-1 1H4v3.5c0 .6-.4 1-1 1z"
    />
  </svg>
);

export const UnMuted = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
    <path
      d="M10.4 0.109017C10.1 -0.090983 9.6 0.00901693 9.3 0.209017L4.6 4.00902H1C0.4 4.00902 0 4.40902 0 5.00902V11.009C0 11.609 0.4 12.009 1 12.009H4.7L9.4 15.809C9.8 16.109 10.5 16.109 10.8 15.609C10.9 15.409 11 15.209 11 15.009V1.00902C11 0.609017 10.8 0.309017 10.4 0.109017ZM15.1 5.40902C15 5.30902 14.9 5.20902 14.9 5.10902C14.5 4.70902 13.9 4.70902 13.5 5.10902C13.1 5.50902 13.1 6.10902 13.5 6.50902C13.8 7.00902 14 7.50902 14 8.00902C14 8.60902 13.7 9.20902 13.3 9.50902C12.9 9.90902 12.8 10.509 13.2 10.909C13.6 11.309 14.2 11.409 14.6 11.009C16.3 9.60902 16.5 7.10902 15.1 5.40902ZM18.1 2.90902C18 2.70902 17.8 2.60902 17.6 2.40902C17.2 2.00902 16.6 2.00902 16.2 2.40902C15.8 2.80902 15.8 3.40902 16.2 3.80902C18.5 6.10902 18.5 9.90902 16.2 12.309C16.1 12.409 15.9 12.509 15.8 12.709C15.4 13.109 15.3 13.709 15.7 14.109C16.1 14.509 16.7 14.609 17.1 14.209C20.5 11.309 21 6.20902 18.1 2.90902Z"
      fill="white"
    />
  </svg>
);

export const Muted = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
    <path
      d="M10.4 0.109017C10.1 -0.090983 9.6 0.00901693 9.3 0.209017L4.6 4.00902H1C0.4 4.00902 0 4.40902 0 5.00902V11.009C0 11.609 0.4 12.009 1 12.009H4.6L9.3 15.809C9.7 16.109 10.4 16.109 10.7 15.609C10.8 15.409 10.9 15.209 10.9 15.009V1.00902C11 0.609017 10.8 0.309017 10.4 0.109017ZM17.9 8.00902L19.7 6.20902C20.1 5.80902 20.1 5.20902 19.7 4.80902C19.3 4.40902 18.7 4.40902 18.3 4.80902L16.5 6.60902L14.7 4.80902C14.3 4.40902 13.7 4.40902 13.3 4.80902C12.9 5.20902 12.9 5.80902 13.3 6.20902L15.1 8.00902L13.3 9.80902C12.9 10.209 12.9 10.809 13.3 11.209C13.7 11.609 14.3 11.609 14.7 11.209L16.5 9.40902L18.3 11.209C18.7 11.609 19.3 11.609 19.7 11.209C20.1 10.809 20.1 10.209 19.7 9.80902L17.9 8.00902Z"
      fill="white"
    />
  </svg>
);

export const Play = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path
      d="M10.5 4.60106C11.8333 5.37086 11.8333 7.29536 10.5 8.06516L3 12.3953C1.66666 13.1651 -6.49976e-07 12.2028 -5.82678e-07 10.6632L-2.04126e-07 2.00298C-1.36828e-07 0.463379 1.66667 -0.498868 3 0.270933L10.5 4.60106Z"
      fill="white"
    />
  </svg>
);

export const Pause = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
    <path
      d="M6.74992 13.5885C6.74992 14.693 5.85449 15.5885 4.74992 15.5885L1.99994 15.5885C0.895367 15.5885 -6.16774e-05 14.693 -6.16291e-05 13.5885L-6.11226e-05 2C-6.10743e-05 0.895428 0.89537 -4.09913e-07 1.99994 -4.00646e-07L4.74992 -3.77573e-07C5.85449 -3.68306e-07 6.74992 0.89543 6.74992 2L6.74992 13.5885Z"
      fill="white"
    />
    <path
      d="M15.0039 13.5886C15.0039 14.6931 14.1085 15.5886 13.0039 15.5886L10.2539 15.5886C9.14934 15.5886 8.2539 14.6931 8.2539 13.5886L8.25391 2.00012C8.25391 0.895551 9.14934 0.000121965 10.2539 0.000121974L13.0039 0.000121997C14.1085 0.000122006 15.0039 0.895553 15.0039 2.00012L15.0039 13.5886Z"
      fill="white"
    />
  </svg>
);
